export default "__VITE_ASSET__CTGjWOQL__"